import { useQuery } from "@tanstack/react-query";

import { api } from "./api";
import { API_URL } from "./env";

// BlobShip has NO local auth. "Session" = the verified OpsBelt token (parked in
// an httpOnly cookie by the API's OIDC callback). useSession just asks the API
// who we are; login/logout are redirects to the API's OIDC endpoints.

export function useSession() {
  const q = useQuery({
    queryKey: ["session"],
    queryFn: api.me,
    retry: false,
    staleTime: 60_000,
  });
  // Shape-compatible with the old Better Auth client: { data, isPending }.
  return { data: q.isError ? null : q.data, isPending: q.isLoading };
}

/** Send the user to OpsBelt to sign in / sign up, then back to BlobShip. */
export function login() {
  window.location.href = `${API_URL}/api/auth/login`;
}

/** Clear the local token cookie and return to the sign-in screen. */
export async function signOut() {
  sessionStorage.removeItem("bs_authed");
  await fetch(`${API_URL}/api/auth/logout`, {
    method: "POST",
    credentials: "include",
  });
  window.location.href = "/login";
}
